import * as $ from 'jquery';
import './repeatable-field-group.less';
import { getUID } from '../../../../utility/key-generator';
import { MaskService } from '../../../../form-services/mask.service';



export class RepeatableFieldGroupCommon  {

    static initRepeatableFieldGroup(container){
        container.find('[name^="field_"]').each((ind,item)=>{
            let name = $(item).attr('name');
            if($(item).attr('id') == undefined){
                $(item).attr('id',name);
            }
            if(name.slice(-2) !== '[]'){
                name+= '[]';
            }
            $(item).attr('name',name);
        });
        container.find('.add-repeatable').off('click').on('click',()=>{
            console.log('add-repeatable')
            let columns = container.find('.repeatable-base-items').data('columns');
            let template = RepeatableFieldGroupCommon.clearInput($('<div class="repeatable-items repeatable-columns-'+columns+'" data-columns="'+columns+'">'+container.find('.repeatable-base-items').html()+'<button type="button" class="item-remove"><svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24"><path d="M19 6.41L17.59 5L12 10.59L6.41 5L5 6.41L10.59 12L5 17.59L6.41 19L12 13.41L17.59 19L19 17.59L13.41 12z"/></svg></button></div>'));
            container.find('.repeatable').append(template);
            template.find('input[data-pb-inputmask]').each((i, inp) => {
                let el = $(inp);
                MaskService.createMask(`input[name="${el.attr('name')}"]`, el.attr('data-pb-inputmask'), () => {}, () => {});
            });
        });
        container.find('.item-remove').off('click');
        container.on('click','.item-remove',(e)=>{
            let button = $(e.target);
            button.closest('.repeatable-items').remove();
        });
    }

    static clearInput(container){
        container.find(':input').each(function(ind,item) {
            // @ts-ignore
            $(item).attr('data-dirty',false);
            $(item).attr('id','repId-'+getUID());
            switch(item.type) {
                case 'password':
                case 'text':
                case 'textarea':
                case 'file':
                case 'select-one':
                case 'select-multiple':
                case 'date':
                case 'number':
                case 'tel':
                case 'email':
                    $(item).val('');
                    break;
                case 'checkbox':
                case 'radio':
                    item.checked = false;
                    break;
            }
            $(item).closest('.form-builder-input').find('label.error').remove();
          });
        return container;
    }




}
